"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Box = void 0;

var _react = _interopRequireDefault(require("react"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * Funnel box component
 **/
var Box = function Box(_ref) {
  var children = _ref.children,
      _ref$noBgColor = _ref.noBgColor,
      noBgColor = _ref$noBgColor === void 0 ? false : _ref$noBgColor;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "".concat(_styleModule.default.box, " ").concat(noBgColor ? _styleModule.default['noBgColor'] : ''),
    children: children
  });
};

exports.Box = Box;
var _default = Box;
exports.default = _default;